import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import * as _ from 'lodash';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  options: any = {};

  generate(entity: any, options) {
    this.options = options;

    let products: UntypedFormGroup[] = [];

    const productsList = entity?.products;
    if (productsList)
      _.forEach(productsList, (product, i) =>
        products.push(this.formBuilder.group(this.createModel(product))),
      );

    let group = this.formBuilder.group({
      products: this.formBuilder.array(products, Validators.nullValidator),
    });

    this.form = group;

    return group;
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }
  public createModel(item) {
    let model = {
      id: [item.id],
      type: [item.type],
      productId: [item.productId],
      productName: [item.productName],
      status: [item.status],
      parameters: this.formBuilder.group({
        scpiPartDivisible: [item?.parameters?.scpiPartDivisible || false],
      }),
    };
    return model;
  }

  extract() {
    return this.form.value;
  }
}
